import { useState as o, useCallback as E, useEffect as I } from "react";
const T = 1e3, f = 1e3, v = (t, r = T, s = f) => {
  const [e, a] = o(t), l = E(() => a(t), [t]);
  return I(() => {
    const n = setInterval(() => {
      a((c) => c - s);
    }, r);
    return e === 0 && clearInterval(n), () => clearInterval(n);
  }, [e, s, r]), {
    countdown: e,
    reset: l
  };
};
export {
  v as useTimer
};
